import classNames from 'classnames';
import map from 'lodash/map';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsTournamentsRounds} from '../../../../../../actions/entities/statistics/tournaments';
import earthFlag from '../../../../../../assets/img/other/flag-earth.svg';
import DateRangePickerWrapper from '../../../../../../components/DatePicker/DateRangePickerWrapper';
import Loader from '../../../../../../components/Loader';
import './index.css';
import FilterLocation from '../../../../../../components/Filters/Location';
import {getChampionships} from '../../../../../../actions/entities/championships';
import {isEmpty} from 'lodash';
import getAvailableFlagsButtons from '../../../../../../helpers/getAvailableFlagsButtons';
import {champIds} from '../../../../../../helpers/championship';

const intervals = {
  0: 'Abort (non lancé car pas assez de participant)',
  1: '2',
  2: '3->4',
  3: '5->8',
  4: '9->16',
  5: '17-32',
  6: '33-64',
  7: '65-128',
  8: '129-256',
  9: '257-512',
  10: '513-1025',
  11: '1025 ou plus',
};

class TournamentsSizesWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {start, end, lang: 'ALL', championship: 'FR'};
  }

  fetchStats() {
    const {start, end} = this.state;
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        fetchStatsTournamentsRounds(
          {
            startDate: start,
            endDate: end,
          },
          null,
          (type, error) =>
            swal({
              title: `Oops...`,
              type: 'error',
              html:
                `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                `<pre><code>${JSON.stringify(
                  error,
                  undefined,
                  4,
                )}</code></pre>`,
            }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  static renderRow(name, creationsByChampionships, championship) {
    const transformName = name === 'public' ? 'Public' : 'Privé';
    const currentChampionshipIds = champIds[championship];
    const currentChampionship =
      creationsByChampionships[currentChampionshipIds];
    const keys = Object.keys(currentChampionship);

    return (
      <tr key={name}>
        <td style={{width: '150px'}}>dont {transformName}</td>
        <td style={{width: '150px', textAlign: 'center'}}>
          <div>
            {map(currentChampionship, (value, index) => {
              return (
                <div key={index}>
                  <b>{index}</b>
                </div>
              );
            })}
          </div>
        </td>
        <td style={{width: '400px', textAlign: 'center'}}>
          {map(keys, (value, index) => {
            return (
              <div>
                <b>{intervals[index]}</b>
              </div>
            );
          })}
        </td>
        <td style={{width: '150px', textAlign: 'center'}}>
          {map(currentChampionship, (value, index) => {
            return (
              <div key={index}>
                <b>{value.current}</b>
              </div>
            );
          })}
        </td>
      </tr>
    );
  }

  renderTable(table, championship) {
    if (!table) return false;
    return (
      <div className="mt-3 table-responsive">
        <table className="table table-striped">
          <thead>
            <tr className="bg-gray">
              <th>Tournoi</th>
              <th style={{textAlign: 'center'}}>Nombre de tours</th>
              <th style={{textAlign: 'center'}}>Intervalles</th>
              <th style={{textAlign: 'center'}}>Quantités</th>
            </tr>
          </thead>
          <tbody>
            {map(table, (mode, modeName) => {
              return TournamentsSizesWidget.renderRow(
                modeName,
                mode,
                championship,
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderTournamentsCreatedByMode() {
    const {statistics, isFetching} = this.props;
    const {lang, championship} = this.state;
    const table = statistics && statistics.data?.[lang];

    return (
      !isFetching &&
      statistics && (
        <div className="mb-4">{this.renderTable(table, championship)}</div>
      )
    );
  }

  toggleChamp(value) {
    this.fetchStats(value);
    this.setState({championship: value});
  }

  componentDidMount() {
    this.props.dispatch(getChampionships());
  }

  render() {
    const {end, start, lang, championship} = this.state;
    const {isFetching, championships} = this.props;

    if (isEmpty(championships)) {
      return <></>;
    }

    return (
      <div id="tournaments-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-trophy" /> Nombre de tournois lancés
            </h3>
            <br />
            Nombre de tournois lancés (live et terminé ou annulé) par range de
            participants
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <FilterLocation
                  availableButtons={getAvailableFlagsButtons(
                    this.props.championships,
                  )}
                  onChange={championship => this.toggleChamp(championship)}
                  initialValue={championship}
                />
                <DateRangePickerWrapper
                  initialStartDate={moment(start)}
                  initialEndDate={moment(end)}
                  minimumNights={0}
                  onDatesChange={({startDate, endDate}) => {
                    this.setState({
                      start: moment(startDate).format('YYYY-MM-DD'),
                      end: moment(endDate).format('YYYY-MM-DD'),
                    });
                  }}
                />
                <button
                  className="ml-2 inline btn btn-default"
                  onClick={() => this.fetchStats()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderTournamentsCreatedByMode()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {statistics, championships} = state.app;
    return {
      statistics: statistics.tournamentsRounds,
      championships: championships.list.data,
    };
  },
  dispatch => ({dispatch}),
)(TournamentsSizesWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Tournaments/Sizes/index.js